import { Cell } from 'exceljs';

// Formats a numeric cell with as many decimal places as the raw value has (e.g. "0.600" -> 3, "0.8000" -> 4),
// so Excel's General format doesn't collapse trailing zeros that the raw data actually carries.
export function setNumericOrTextCellValue(cell: Cell, rawValue: string | number): void {
    const strValue = String(rawValue ?? '').trim();
    if (strValue !== '' && !isNaN(Number(rawValue))) {
        cell.value = Number(rawValue);
        const decimalMatch = strValue.match(/\.(\d+)$/);
        cell.numFmt = decimalMatch ? '0.' + '0'.repeat(decimalMatch[1].length) : '0';
    } else {
        cell.value = rawValue;
    }
}
